export enum NativeMessageSources {
  PWA = 'pwa',
  NATIVE = 'native',
}
